import React, { useEffect, useRef, useState } from "react";
import { GenericLogOut } from "@heathmont/moon-icons";
import { useNavigate } from "react-router-dom";
import { getBorderColor, getTextColor } from "../../../utils/Colors/colorSetting";
import { capitalizeWords } from "../../../utils/capitalizeWords";
import { logout } from "../../../services/auth.service";

const ProfileButton = ({ value, role, imageUrl, roles }: any) => {
  const [open, setOpen] = useState(false);
  const borderColor = getBorderColor(role);
  const textColor = getTextColor(role);
  const navigate = useNavigate();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const logOut = () => {
    setOpen(false);
    logout();
  };

  return (
    <div ref={ref} className="relative">
      {/* Trigger */}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 font-semibold text-[15px] text-white py-0.5 px-1.5 rounded-xl cursor-pointer capitalize hover:bg-white/10 transition-colors"
      >
        <span className="w-6 h-6 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-white">
            <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
          </svg>
        </span>
        <span>{capitalizeWords(value)}</span>
      </button>

      {/* Dropdown panel */}
      {open && (
        <div className="absolute right-0 mt-2 w-52 rounded-xl bg-white shadow-moon-lg border border-gray-100 z-[9999] overflow-hidden">
          {/* Profile card */}
          <div className="text-center p-3">
            <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full border-2 bg-gray-100 mb-1 ${borderColor}`}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-10 h-10 text-gray-400">
                <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
              </svg>
            </div>
            <h3 className="text-moon-14 capitalize font-semibold">{capitalizeWords(value)}</h3>
            <p className={`text-xs ${textColor}`}>{capitalizeWords(role)}</p>
          </div>
          <hr className="border-gray-100" />
          <button
            type="button"
            onClick={() => { setOpen(false); navigate("/profile"); }}
            className="w-full text-left px-4 py-2 text-sm text-gray-500 hover:bg-gray-50 transition-colors"
          >
            Profile
          </button>
          <hr className="border-gray-100" />
          <button
            type="button"
            onClick={logOut}
            className="w-full text-left px-4 py-2 text-sm flex items-center gap-2 text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <GenericLogOut className="text-base" /> Log out
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileButton;
